import { render, staticRenderFns } from "./JoinConfirm.vue?vue&type=template&id=66cfbfc9"
import script from "./JoinConfirm.vue?vue&type=script&lang=js"
export * from "./JoinConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports